import { FC } from 'react';
import { IChildren } from '../../models';
import './styles.scss';

const BotInfo: FC<IChildren> = ({ children }) => (
  <>
    <div className="bot-info__body">
      <div className="bot-info__text">
        <div className="bot-info__text-inner">
          <div className="bot-info__text-content d-flex align-items-center gap-1">
            <h4>KAI Select</h4>
            <div className="bot-info__greeting">
              Kinetix Air AI Agent for selection of Air Handling units
            </div>
            <div className="bot-info__instruction">
            </div>
          </div>
        </div>
      </div>
      {children}
    </div>
  </>
);

export default BotInfo;